import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheetContent } from './action-sheet';
import { FONTS } from '@/styles';
import { StyleSheet } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface Props {
  onAction: () => void;
}

export const TagPrintBatchTemplateUnavailableOffline: React.FC<Props> = ({
  onAction,
}) => {
  return (
    <ActionSheetContent
      actions={[i18n.t('select_different_template')]}
      buttonContainerStyle={styles.buttonContainerStyle}
      message={
        <Typography variant="paragraph-base">
          {i18n.t('template_unavailable_offline.message')}
        </Typography>
      }
      onAction={onAction}
      title={i18n.t('template_unavailable_offline.title')}
      titleStyle={styles.titleStyle}
    />
  );
};

const styles = StyleSheet.create({
  buttonContainerStyle: {
    marginTop: 24,
  },
  titleStyle: {
    ...FONTS.primarySemiBold,
    fontSize: 21,
    marginBottom: 8,
    textAlign: 'left',
  },
});
